import LocationViewModel from './locationviewmodel';
import DeptLocCommCollection from '../collection/deptloccommcollection';
const DeptLocModel = Backbone.Model.extend({
  defaults: {
    "errorMessage": "",
    "modifyUserID": 0,
    "departmentLocationID": 0,
    "departmentID": 0,
    "locationID": 0,
    "isActive": false,
    "location": {}, // new phillips.LocationViewModel
    "departmentLocationCommunications": {} //new phillips.DeptLocCommCollection
  },
  initialize: function() {
    this.set({
      "id": this.get("departmentLocationID"),
      "location" : new LocationViewModel(this.get("location")),
      "departmentLocationCommunications" : new DeptLocCommCollection(this.get("departmentLocationCommunications"))
    });
  }
});

export default DeptLocModel;
